import { patchData } from '~/utils/service';
import { OnUpdateEvent, Scope } from '../../step-machine/types';
import { AdditionalTermsFormValues } from './types';

type AdditionalTermsRouteName = 'msaasDetails' | 'jobListingDetails';

// [MCV-1901] The route was hardcoded to the B2B details endpoint, so the Job
// wizard PATCHed /b2b/details/{jobDetailId}: the job's terms never saved, and an
// unrelated B2B row with the same numeric id could be overwritten. Each listing
// kind now gets its own route.
const createPatch =
  (routeName: AdditionalTermsRouteName) =>
  async ({ input }: { input: Scope<AdditionalTermsFormValues> }) => {
    const event = input.event as OnUpdateEvent<AdditionalTermsFormValues>;
    // The id belongs in the path and the parent ids are not editable on a detail
    // row, so the body is an allow-list of the four term fields only.
    const { id, bonusesTxt, adminCostsTxt, infrastructureTxt, extraTxt } = event.payload.values;
    return await patchData(routeName, {
      pathParams: { id: id?.toString() || '' },
      data: { bonusesTxt, adminCostsTxt, infrastructureTxt, extraTxt },
    });
  };

export const API_CALLS = {
  patchMsaas: createPatch('msaasDetails'),
  patchJob: createPatch('jobListingDetails'),
};
